import SectionLabel from '../../../../../components/SectionLabel';
import { Grid, Input, InputOnChangeData } from 'semantic-ui-react';
import { Field } from 'formik';
import { maskZipCode } from '../../../../../services/masks';
import { FormikErrorMessage } from '../../../../../components/ErrorMessage';
import { AddressService } from '../../../../../services/address';
import React, { ReactElement, SyntheticEvent, useState } from 'react';
import { getErrorFormik } from '../../../../../services/errors';
import { FieldLabel } from '../../../../../styles';
import { StepProps } from '../../../BondInsuranceForm';
import { connect } from 'react-redux';
import { iRootDispatch, iRootState } from '../../../../../store';
import { BondInsuranceFormState } from '../../../../../store/types/temp-types';
import { UFOptions, hirePropertyTypeOptions } from '../../../types';
import Dropdown from '../../../../../components/Dropdown';
import { SpacedColumn } from '../../../style';
import styled from 'styled-components';
import PropertyWalletSearchDropdown from './PropertyWalletSearchDropdown';

const SECTION_NAME = 'property_info';

const mapState = (state: iRootState) => ({
  bondInsuranceForm: state.bondInsuranceForm,
  user: state.user
});

const mapDispatch = (dispatch: iRootDispatch) => ({
  updateBondInsurance: (bondInsuranceFormState: BondInsuranceFormState) =>
    dispatch.bondInsuranceForm.updateBondInsurance(bondInsuranceFormState)
});

type PropertyAddressProps = StepProps &
  ReturnType<typeof mapState> &
  ReturnType<typeof mapDispatch>;

const PropertyAddress = (props: PropertyAddressProps): ReactElement => {
  const [cepLoading, setCepLoading] = useState<boolean>(false);
  const {
    errors,
    touched,
    setFieldTouched,
    setFieldValue,
    setFieldError,
    handleInputChange,
    // handleDateChange,
    user,
    values
  } = props;
  const selectedEstate = values?.initial_info?.estate as
    | { id?: string; rv_uuid?: string; rvUuid?: string }
    | undefined;
  const estateId = selectedEstate?.id;
  const selectedFromWallet = Boolean(values?.property_info?.property_public_id);
  const isFieldLocked = selectedFromWallet;

  const onChangeCep = (e: React.ChangeEvent<HTMLInputElement>): void => {
    if (isFieldLocked) return;

    const maskedValue = maskZipCode(e.target.value);

    setFieldValue(`${SECTION_NAME}.zip_code`, maskedValue);
    if (maskedValue.length === 9) {
      setCepLoading(true);

      AddressService.getAddressByZipCode(e.target.value, user.id)
        .then(address => {
          setFieldValue(`${SECTION_NAME}.city`, address.city);
          setFieldValue(`${SECTION_NAME}.district`, address.district);
          setFieldValue(`${SECTION_NAME}.state`, address.state);
          setFieldValue(`${SECTION_NAME}.street`, address.street);

          setCepLoading(false);
        })
        .catch(e => {
          console.log('address error:', e);
          setCepLoading(false);
          setFieldError(
            `${SECTION_NAME}.zip_code`,
            'CEP não encontrado. Verifique o CEP informado.'
          );
        });
    }
  };

  const validateErros = (field: string) =>
    getErrorFormik(errors, touched, SECTION_NAME, field);

  return (
    <>
      <SectionLabel text="ENDEREÇO DO IMÓVEL" />
      <PropertyWalletSearchDropdown
        estateId={estateId}
        setFieldValue={setFieldValue}
        values={values}
      />
      {selectedFromWallet && (
        <Grid.Row style={{ marginTop: '-6px' }}>
          <Grid.Column mobile={16} tablet={16} computer={16}>
            <WalletTag>Imóvel selecionado da carteira — endereço preenchido automaticamente</WalletTag>
          </Grid.Column>
        </Grid.Row>
      )}
      <Grid.Row>
        <SpacedColumn mobile={16} tablet={6} computer={5}>
          <FieldLabel>CEP*</FieldLabel>
          <Field
            id={`${SECTION_NAME}.zip_code`}
            name={`${SECTION_NAME}.zip_code`}
            value={values.property_info.zip_code}
            loading={cepLoading}
            onChange={(
              e: React.ChangeEvent<HTMLInputElement>,
              data: InputOnChangeData
            ): void => {
              onChangeCep(e);
              data.value = maskZipCode(e.target.value);
            }}
            onBlur={() => setFieldTouched(`${SECTION_NAME}.zip_code`, true)}
            error={validateErros('zip_code')}
            component={Input}
            maxLength={9}
            fluid
            disabled={isFieldLocked}
          />
          <FormikErrorMessage component="div" name={`${SECTION_NAME}.zip_code`} />
        </SpacedColumn>

        <SpacedColumn mobile={16} tablet={10} computer={11}>
          <FieldLabel>LOGRADOURO*</FieldLabel>
          <Field
            id={`${SECTION_NAME}.street`}
            name={`${SECTION_NAME}.street`}
            value={values.property_info.street}
            onChange={handleInputChange}
            onBlur={() => setFieldTouched(`${SECTION_NAME}.street`, true)}
            error={validateErros('street')}
            component={Input}
            fluid
            disabled={isFieldLocked}
          />
          <FormikErrorMessage component="div" name={`${SECTION_NAME}.street`} />
        </SpacedColumn>
      </Grid.Row>

      <Grid.Row>
        <SpacedColumn mobile={16} tablet={8} computer={5}>
          <FieldLabel>BAIRRO*</FieldLabel>
          <Field
            id={`${SECTION_NAME}.district`}
            name={`${SECTION_NAME}.district`}
            value={values.property_info.district}
            onChange={handleInputChange}
            onBlur={() => setFieldTouched(`${SECTION_NAME}.district`, true)}
            error={validateErros('district')}
            component={Input}
            fluid
            disabled={isFieldLocked}
          />
          <FormikErrorMessage component="div" name={`${SECTION_NAME}.district`} />
        </SpacedColumn>

        <SpacedColumn mobile={16} tablet={8} computer={6}>
          <FieldLabel>CIDADE*</FieldLabel>
          <Field
            id={`${SECTION_NAME}.city`}
            name={`${SECTION_NAME}.city`}
            value={values.property_info.city}
            onChange={handleInputChange}
            onBlur={() => setFieldTouched(`${SECTION_NAME}.city`, true)}
            error={validateErros('city')}
            component={Input}
            fluid
            disabled={isFieldLocked}
          />
          <FormikErrorMessage component="div" name={`${SECTION_NAME}.city`} />
        </SpacedColumn>

        <SpacedColumn mobile={16} tablet={16} computer={5}>
          <FieldLabel>UF*</FieldLabel>
          <Field
            id={`${SECTION_NAME}.state`}
            name={`${SECTION_NAME}.state`}
            value={values.property_info.state}
            completeValue={true}
            options={UFOptions}
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            onChange={(e: SyntheticEvent, data: any) => {
              if (isFieldLocked) return;
              setFieldValue(`${SECTION_NAME}.state`, data.value);
            }}
            error={Boolean(validateErros('state'))}
            onBlur={() => setFieldTouched(`${SECTION_NAME}.state`, true)}
            component={Dropdown}
            selection
            compact
            basic
            fluid
            disabled={isFieldLocked}
          />
          <FormikErrorMessage component="div" name={`${SECTION_NAME}.state`} />
        </SpacedColumn>
      </Grid.Row>

      <Grid.Row>
        <SpacedColumn mobile={16} tablet={8} computer={4}>
          <FieldLabel>NÚMERO*</FieldLabel>
          <Field
            id={`${SECTION_NAME}.number`}
            name={`${SECTION_NAME}.number`}
            value={values.property_info.number}
            onChange={handleInputChange}
            onBlur={() => setFieldTouched(`${SECTION_NAME}.number`, true)}
            error={validateErros('number')}
            component={Input}
            fluid
            disabled={isFieldLocked}
          />
          <FormikErrorMessage component="div" name={`${SECTION_NAME}.number`} />
        </SpacedColumn>

        <SpacedColumn mobile={16} tablet={8} computer={4}>
          <FieldLabel>
            COMPLEMENTO{values.property_info.property_type === 'APARTAMENTO' ? '*' : ''}
          </FieldLabel>
          <Field
            id={`${SECTION_NAME}.complement`}
            name={`${SECTION_NAME}.complement`}
            value={values.property_info.complement}
            onChange={handleInputChange}
            onBlur={() => setFieldTouched(`${SECTION_NAME}.complement`, true)}
            error={validateErros('complement')}
            component={Input}
            maxLength={50}
            fluid
            disabled={isFieldLocked}
          />
          <FormikErrorMessage component="div" name={`${SECTION_NAME}.complement`} />
        </SpacedColumn>

        <SpacedColumn mobile={16} tablet={8} computer={4}>
          <FieldLabel>CÓDIGO DO IMÓVEL</FieldLabel>
          <Field
            id={`${SECTION_NAME}.property_code`}
            name={`${SECTION_NAME}.property_code`}
            value={values.property_info.property_code || ''}
            onChange={handleInputChange}
            onBlur={() => setFieldTouched(`${SECTION_NAME}.property_code`, true)}
            error={validateErros('property_code')}
            component={Input}
            maxLength={30}
            fluid
            disabled={isFieldLocked}
          />
          <FormikErrorMessage component="div" name={`${SECTION_NAME}.property_code`} />
        </SpacedColumn>

        <SpacedColumn mobile={16} tablet={8} computer={4}>
          <FieldLabel>TIPO DO IMÓVEL*</FieldLabel>
          <Field
            id={`${SECTION_NAME}.property_type`}
            name={`${SECTION_NAME}.property_type`}
            value={values.property_info.property_type}
            completeValue={true}
            options={hirePropertyTypeOptions}
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            onChange={(e: SyntheticEvent, data: any) => {
              if (isFieldLocked) return;
              setFieldValue(`${SECTION_NAME}.property_type`, data.value);
            }}
            onBlur={() => setFieldTouched(`${SECTION_NAME}.property_type`, true)}
            error={Boolean(validateErros('property_type'))}
            component={Dropdown}
            selection
            compact
            basic
            fluid
            disabled={isFieldLocked}
          />
          <FormikErrorMessage component="div" name={`${SECTION_NAME}.property_type`} />
        </SpacedColumn>
      </Grid.Row>
    </>
  );
};

export default connect(mapState, mapDispatch)(PropertyAddress);

const WalletTag = styled.span`
  display: inline-block;
  border-radius: 14px;
  background: #f6f1ff;
  color: #5c2599;
  padding: 6px 10px;
  font-size: 12px;
  font-weight: 600;
`;
